import { backdropClasses } from "@mui/material/Backdrop";
import type { Components } from "@mui/material/styles";

import type { Theme } from "../types";

export const MuiMenu = {
	defaultProps: { disableScrollLock: true },
	styleOverrides: {
		root: {
			// Match the global MuiBackdrop filter so Selects/dropdowns whose
			// backdrop is invisible-by-default don't get a modal-style dim+blur
			// overlay that makes them look like dialogs.
			[`& .${backdropClasses.root}:not(.${backdropClasses.invisible})`]: {
				backgroundColor: "rgba(0, 0, 0, 0.45)",
				backdropFilter: "blur(3px)",
			},
		},
		list: {
			display: "flex",
			flexDirection: "column",
			gap: "4px",
			padding: "8px",
		},
	},
} satisfies Components<Theme>["MuiMenu"];
